import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, Link, Stack, Typography } from '@mui/material';

export function EmailVerifiedPage() {
  const [searchParams] = useSearchParams();
  const verified = searchParams.get('verified');
  const interactionId = searchParams.get('interaction');

  const signInHref =
    interactionId !== null
      ? `/auth/signin?interaction=${encodeURIComponent(interactionId)}`
      : '/auth/signin';

  if (verified === 'true') {
    return (
      <Box sx={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
        <Card sx={{ width: '100%', maxWidth: 520 }}>
          <CardContent>
            <Stack spacing={3}>
              <Stack spacing={1}>
                <Typography variant="h5" component="h1" fontWeight={700}>
                  Email verified
                </Typography>
              </Stack>
              <Alert severity="success">Your email address has been verified.</Alert>
              <Typography variant="body1">You can now sign in to your Ayeldo account.</Typography>
              <Button component={RouterLink} to={signInHref} variant="contained">
                Sign in
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <Card sx={{ width: '100%', maxWidth: 520 }}>
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="h5" component="h1" fontWeight={700}>
              Email verification failed
            </Typography>
            <Alert severity="error">
              Email verification failed or the link has expired. Please request a new verification
              email.
            </Alert>
            <Typography variant="body2">
              <Link component={RouterLink} to="/auth/signin" underline="hover">
                Return to sign in
              </Link>
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
